import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CareersPage from "../pages/careers/page";
import JobDetailPage from "../pages/careers/JobDetailPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/careers/:slug",
    element: <JobDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
